import React, { useState } from 'react';
import { Brikk } from 'components/Brikk';
import schoolBook from 'assets/media/school-book.jpg';
import Draggable from 'components/drag-and-drop/Draggable';
import { NewPageButton } from 'components/form-elements/buttons/NewPageButton';
import { OfficialBuildingIcon } from 'assets/icons/brikks/OfficialBuildingIcon';
import { LinkBrikkContent } from 'components/brikks/sub-components/LinkBrikkContent';
import { CircularImage } from 'components/brikks/sub-components/CircularImage';
import { BrikkInfoModal } from 'components/modals/BrikkInfoModal';
import { InfoButton } from 'components/form-elements/buttons/InfoButton';

export const Schools = ({ position, status, code, name }) => {
  const [isInfoModalOpen, setIsInfoModalOpen] = useState(false);

  const handleInfoModal = (e) => {
    e.stopPropagation();
    setIsInfoModalOpen(!isInfoModalOpen);
  };

  return (
    <>
      <Draggable position={position}>
        <Brikk
          brikkKey={code}
          name={name}
          status={status}
        >
          <Brikk.Header
            icon={<OfficialBuildingIcon />}
            heading="schoolsBrikk"
            brikkKey={code}
            status={status}
          />

          <Brikk.Content>
            <CircularImage
              src={schoolBook}
              alt="Image of a book"
            />

            <LinkBrikkContent link="skolkollen.se" />
          </Brikk.Content>

          <Brikk.Button>
            <NewPageButton
              label="Schools Link"
              to="https://skolkollen.se/"
              brikkNameIntl="Schools"
            />
            <InfoButton
              showModal={isInfoModalOpen}
              onClick={handleInfoModal}
            />
          </Brikk.Button>
        </Brikk>
      </Draggable>
      <BrikkInfoModal
        title="Schools info"
        // info={info}
        showModal={isInfoModalOpen}
        onClick={() => setIsInfoModalOpen(!isInfoModalOpen)}
      />
    </>
  );
};
